import { Stack } from '@mui/material';
import { Placeholder } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FocusLeePlaceholderImage } from '../common/FocusLeePlaceholderImage';

interface TemplateEmptyStateProps {
  hasSearchQuery: boolean;
}

export const TemplateEmptyState: FC<TemplateEmptyStateProps> = ({ hasSearchQuery }) => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" justifyContent="center" alignItems="center" height="100%">
      <Placeholder
        header={hasSearchQuery ? t('templates.noneFound') : t('templates.noneAvailable')}
        description={hasSearchQuery ? t('templates.adjustSearch') : t('templates.allDone')}
        style={{ padding: 0 }}
      >
        <FocusLeePlaceholderImage kind={hasSearchQuery ? 'templatesSearch' : 'templates'} />
      </Placeholder>
    </Stack>
  );
};
